/**
 * Calcula la edad a partir de una fecha de nacimiento.
 * @param {string|Date} birthDate - Fecha de nacimiento (ISO string o Date)
 * @returns {number|null} Edad en años, o null si no hay fecha
 */
export const calculateAge = (birthDate) => {
  if (!birthDate) return null;
  const birth = new Date(birthDate);
  if (isNaN(birth.getTime())) return null;
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  return age;
};

/**
 * Formatea una fecha de nacimiento para mostrar
 * @param {string|Date} birthDate
 * @returns {string} Fecha formateada o '—'
 */
export const formatBirthDate = (birthDate) => {
  if (!birthDate) return '—';
  const d = new Date(birthDate);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' });
};

/**
 * Formatea nombres de personas (atletas, entrenadores, apoderados)
 * a Title Case: primera letra de cada palabra mayúscula, resto minúscula.
 * Respeta partículas comunes en español (de, la, del, las, los, y).
 * Preserva iniciales con punto (J.) y nombres compuestos con guion.
 *
 * @param {string} name
 * @returns {string}
 */
export const formatPersonName = (name) => {
  if (!name || typeof name !== 'string') return name || '';
  const particles = new Set(['de', 'del', 'la', 'las', 'los', 'y', 'da', 'do', 'dos', 'das', 'van', 'von', 'di']);
  const capWord = (w) => {
    if (!w) return w;
    // Respetar iniciales tipo "J." o "M.A."
    if (/^[A-ZÁÉÍÓÚÑ]\.$/i.test(w)) return w.toUpperCase();
    // Partes con guion: "Jean-Pierre"
    if (w.includes('-')) return w.split('-').map(capWord).join('-');
    return w.charAt(0).toLocaleUpperCase('es') + w.slice(1).toLocaleLowerCase('es');
  };
  return name
    .trim()
    .replace(/\s+/g, ' ')
    .split(' ')
    .map((word, idx) => {
      const lower = word.toLocaleLowerCase('es');
      // Partículas se mantienen en minúscula excepto si es la primera palabra
      if (idx > 0 && particles.has(lower)) return lower;
      return capWord(word);
    })
    .join(' ');
};

